<template>
	<div class="" id="pageTop" style="padding:1rem 1rem 10rem;">
		<div class="row">
            <div class="alert alert-danger col-12" align="center" role="alert" v-if="loginError">
                Invalid email address or password!
            </div>
			<div class="col-12 col-lg-3">
            </div>
            <div class="col-12 col-lg-6">
                <ul class="list-group">
                    <li class="list-group-item">
                        <div class="row">
                            <div class="col-12 my-2">
                                <h4 align="center">Please login to continue</h4>
                            </div>
                            <div class="col-12 my-2">
                                <label>Email address</label>
                                <input type="email" class="form-control" v-model="login.email"/>
                            </div>
                            <div class="col-12 my-1" v-show="!showPassword">
                                <button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid || isBusy" @click="btnContinueClick">
                                    <span v-show="!isBusy">Continue</span>
                                    <div class="spinner-border text-light" role="status" v-show="isBusy">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </button>
                            </div>
                            <div class="col-12 my-2" v-show="showPassword">
                                <label>Password</label>
                                <input type="password" class="form-control"  v-model="login.pass" />
                                <p align="right">
                                    <button class="btn btn-link btn-sm" @click="$router.push('/forgot-password')">
                                        Forgot password
                                    </button>
                                </p>
                            </div>
                            <div class="col-12 my-1" v-show="showPassword">
                                <button class="btn btn-block btn-primary btn-lg" :disabled="!isLoginFormValid || isBusy" @click="btnLoginClick">
                                    <span v-show="!isBusy">Sign in</span>
                                    <div class="spinner-border text-light" role="status" v-show="isBusy">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </button>
                            </div>
                            <div class="col-12 my-3" align="center">
                                &nbsp;
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-lg-3">
            </div>
		</div>
	</div>
</template>

<script>
    const fb = require("../firebaseConfig")
	export default {
		name: "Login",
		filters: {

		},
		components: {
			
		},
		computed:{
            isFormValid(){
                if(!this.login.email) return false
                if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.login.email)) return false
                return true
            },
			isLoginFormValid(){
                if(!this.login.email) return false
                if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.login.email)) return false
                if(!this.login.pass) return false
                return true
            }
		},
		data(){
			return{
                loginError:false,
				isBusy: false,
                login:{
                    email:'',
                    pass:'',
                },
                showPassword:false,
			}
		},
		methods:{
            btnContinueClick(){
                this.isBusy = true
                fb.firebase.auth().fetchSignInMethodsForEmail(this.login.email).then((result) => {
                    if(result[0] == "password"){
                        this.showPassword = true
                        this.isBusy = false
                    }else{
                        this.isBusy = false
                        this.$router.push("/signup")
                    }
                })
                .catch((error) => {
                    console.log(error.code, error.message)
                    this.isBusy = false
                    this.loginError = true
                });
            },
			btnLoginClick(){
                this.isBusy = true
                this.loginError = false
                fb.firebase.auth().signInWithEmailAndPassword(this.login.email, this.login.pass)
                .then((userCredential) => {
                    let user = userCredential.user
                    this.$store.dispatch("fetchProfile", user)
                    this.isBusy = false
                    if(typeof this.$route.query.from !== "undefined"){
                        let decoded_uri = decodeURIComponent(this.$route.query.from)
                        this.$router.push(decoded_uri)
                    }else{
                        this.$router.push("/")
                    }
                })
                .catch((error) => {
                    console.log(error.code, error.message)
                    this.isBusy = false
                    this.loginError = true
                });
            }
		},

		mounted(){
            this.$store.commit("setPageTitle", "")
        }

	}
</script>
